import * as yup from 'yup';

export const siteAddress = yup.object().shape({
	address: yup.string().required('Address is required.'),
	city: yup.string().required('City is required.'),
	state: yup.string().required('State is required.'),
	zip: yup
		.string()
		.required('Zip Code is required.')
		.matches(/[0-9]{5}/g, 'Invalid Zip Code.'),
});

export const siteInfo = yup.object().shape({
	parcelNumbers: yup.array().of(
		yup.object().shape({
			parcelNumber: yup
				.string()
				.required('Parcel number is required.')
				.matches(/[0-9]{2}:[0-9]{3}:[0-9]{4}/g, 'Invalid parcel number'),
		})
	),
	acres: yup
		.number()
		.nullable(true)
		.required('Site size in acres is required.')
		.typeError('Invalid number.'),
});

export const burnSiteSchema = yup.object().concat(siteInfo).concat(siteAddress);
